export function Release_2_0() {
    return (
      <div>
        <h2 className="text-sm text-gray-400">Release on: 17 August 2025</h2>
        <h2 className="text-xl font-semibold text-purple-300">Overview</h2>
        <p className="text-gray-200">
              CashMate 2.0 represents a significant leap forward in our mission to provide comprehensive business management solutions for SMEs in Malaysia. 
              This release introduces powerful new features, enhanced performance, and improved user experience across all modules, making it easier than 
              ever to manage your business operations efficiently while staying compliant and consistently adding new features.
            </p>
  
        <h2 className="text-xl font-semibold text-purple-300 mt-6">New Features</h2>
        <h3 className="text-lg font-semibold text-white mt-3">Artificial Intelligence</h3>
        <ul className="list-disc list-inside">
            <li>All fetures using AI will be availble on future update including stock predictions, sales predictions and so on.</li>
        </ul>
        <h3 className="text-lg font-semibold text-white mt-3">Cashier</h3>
        <ul className="list-disc list-inside">
            <li>User can now make bundle/sets of products.</li>
        </ul>
        <h3 className="text-lg font-semibold text-white mt-3">Sales Report</h3>
        <ul className="list-disc list-inside">
            <li>New type of report to sync with accounting functions.</li>
            <li>All accounting features is NOT YET sync with any reports.</li>
        </ul>
        <h3 className="text-lg font-semibold text-white mt-3">Inventory Management</h3>
        <ul className="list-disc list-inside">
            <li>User can now create bundle/sets of products, each quantity of bundle will be set to the lowest quantity of the product in the bundle/sets.</li>
            <li>Real-time inventory deduction upon sale or order saving, including smart logic to avoid double deduction on previously saved orders.</li>
        </ul>
        <h3 className="text-lg font-semibold text-white mt-3">Dashboard Overview</h3>
        <ul className="list-disc list-inside">
            <li>Smart stock monitoring system that can notify is stocks are low.</li>
        </ul>
        <h3 className="text-lg font-semibold text-white mt-3">Accounting</h3>
        <ul className="list-disc list-inside">
            <li>All new accounting fetures for users to keep track of financials.</li>
            <li>Some of the features in accounting is not available until future update.</li>
        </ul>   
        <h3 className="text-lg font-semibold text-white mt-3">Backup</h3>
        <ul className="list-disc list-inside">
            <li>Backup feature is now available for users to backup their data.</li>
            <li>Backup can be downloaded as CSV file.</li>
        </ul>   

        <h2 className="text-xl font-semibold text-purple-300 mt-6">Resolved Issues</h2>
        <ul className="list-disc list-inside">
            <li>UI enhancement.</li>
            <li>New onboarding guide for users to guide them through the app.</li>
            <li>Fixed wrong calculation for reports including bundle/sets are now sync.</li>
            <li>Fixed type of prodct error when adding product.</li>
            <li>Fixed bundle stock not syncing correctly in cashier.</li>
            <li>Fixed save state for sidebar settings.</li>
            <li>Fixed remove button in product table.</li>
            <li>Fixed stock level for bundle in inventory. </li>
        </ul>

        <h2 className="text-xl font-semibold text-purple-300 mt-6">Known Issues</h2>
        <ul className="list-disc list-inside">
            <li>Accounting related transactions is not sync with any reports, for now it is only for recording purpose.</li>
            <li>Import feature is not available until future update.</li>
            <li>Some pages may have issue in mobile view.</li>
        </ul>

        <h2 className="text-xl font-semibold text-purple-300 mt-6">Compatible Devices</h2>
        <ul className="list-disc list-inside">
            <li>Best view on desktop and tablet size.</li>
            <li>Compatible with all devices running on Chrome, Firefox, Safari, and Edge.</li>
        </ul>
      </div>
      
    );
  }
